import { useState, useCallback } from 'react';

/**
 * Custom hook for managing validation errors from API responses
 * Provides consistent validation error handling across all form components
 */
export function useValidationErrors() {
  const [validationErrors, setValidationErrors] = useState<{[key: string]: string[]}>({});

  /**
   * Remove validation error for a specific field
   * @param key - The field name to remove validation errors for
   */
  const removeValidationError = useCallback((key: string) => {
    if (validationErrors[key]) {
      const { [key]: _, ...rest } = validationErrors;
      setValidationErrors(rest);
    }
  }, [validationErrors]);

  /**
   * Clear all validation errors
   */
  const clearAllValidationErrors = useCallback(() => {
    setValidationErrors({});
  }, []);

  /**
   * Set validation errors from API response
   * @param errors - Validation errors object from API response
   */
  const setValidationErrorsFromResponse = useCallback((errors: {[key: string]: string[]}) => {
    setValidationErrors(errors);
  }, []);

  return {
    validationErrors,
    removeValidationError,
    clearAllValidationErrors,
    setValidationErrorsFromResponse,
  };
}